<div class="iwg-form-dialog iwg-contact-dialog contact-vista">
  <img src="../../assets/images/myvista-logo-white.png" class="hoverLogo" alt="logo">
  <mat-toolbar class="mat-iwgGreen-theme">
    <div class="mat-toolbar-tools">
      <span class="vista-contctus">Contact Us</span>
      <span flex></span>
      <button mat-button class="mat-icon-button" (click)="hide()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <mat-dialog-content mat-theme="iwgBlue" hide-xs>
    <mat-card class="mat-padding" layout-fill layout="column" layout-align="center start">
      <div class="vista-contact">
        Please feel free to reach out to us with any questions by phone or email:
      </div>
      <div class="iwg-widget-box-card">
          <p class="iwg-regular-value no-margin">
              <mat-icon class="iconVertical">phone</mat-icon>
              415-800-5980
          </p>
      </div>
      <div class="iwg-widget-box-card">
        <p class="iwg-regular-value no-margin">
          <mat-icon class="iconVertical">email</mat-icon>
          <a href="mailto:help@iworkglobal.com">  help@iworkglobal.com</a>
        </p>
      </div>
    </mat-card>
  </mat-dialog-content>


</div>
